import TabsHelper from './helpers/tabs-helper';

// TODO: lozad 

class MapLocation {
  constructor() {
    this.el = document.querySelector('.map-location');
    this.videoContainer = this.el.querySelector('.map-location-visual');
    this.videoIndex = 'root';
    this.shouldLoadVideos = true;

    this.basePath = '/wp-content/themes/northc-24/dist/static/videos/';

    this.videoFiles = {
      root: 'map-overview.mp4',
      netherlands: {
        transitionTo: 'to-netherlands.mp4',
        loop: 'netherlands.mp4',
        transitionFrom: 'from-netherlands.mp4',
      },
      germany: {
        transitionTo: 'to-germany.mp4',
        loop: 'germany.mp4',
        transitionFrom: 'from-germany.mp4',
      },
      switzerland: {
        transitionTo: 'to-switzerland.mp4',
        loop: 'switzerland.mp4',
        transitionFrom: 'from-switzerland.mp4',
      },
    };
      
    this.previousCountry = null;
    this.currentCountry = null;
  }
  
  init() {
    if (!this.el) return;

    this.setProperties();
    this.addEventListeners();
    this.loadVideos();
  }
  
  setProperties() {
    this.countryTabs = this.el.querySelectorAll('.map-location-tab-link');
    this.closeTabButtons = this.el.querySelectorAll('.close-tab');
  }

  loadVideos() {
    if (!this.shouldLoadVideos) {
      return;
    }

    Object.entries(this.videoFiles).forEach(([key, value]) => {
      if (key !== 'root') {
        const types = ['transitionTo', 'loop', 'transitionFrom'];

        types.forEach((type) => {
          const videoElement = document.createElement('video');

          videoElement.muted = true;
          videoElement.preload = true;
          videoElement.playsinline = true;
          videoElement.id = MapLocation.getVideoElementId(key, type);
          videoElement.setAttribute('muted', 'true');
          videoElement.setAttribute('playsinline', 'true');
          videoElement.setAttribute('disablepictureinpicture', 'true');

          if (type === 'loop') {
            videoElement.loop = true;
          }
    
          const sourceElement = document.createElement('source');
          sourceElement.src = this.basePath + value[type];
          sourceElement.type = 'video/mp4';
          videoElement.appendChild(sourceElement);
  
          this.videoContainer.appendChild(videoElement);
        });
      }
    });
  }

  addEventListeners() {
    this.countryTabs.forEach((countryTab) => {
      countryTab.addEventListener('click', (event) => {
        event.preventDefault();

        const tabButton = event.currentTarget;
        const tabInstance = window.BootstrapTab.getOrCreateInstance(tabButton);

        this.setCurrentCountry(tabButton.dataset.countryId, () => {
          if (tabInstance) {
            tabInstance.show();
          }
        });
      });
    });

    this.closeTabButtons.forEach((closeTabButton) => {
      closeTabButton.addEventListener('click', (event) => this.handleCloseButton(event));
    });
  }
  
  handleCloseButton(event) {
    const currentTabPane = event.currentTarget.closest('.tab-pane');
    const activeTab = this.el.querySelector(`.map-location-tab-link[data-bs-target="#${currentTabPane.id}"]`);

    this.setCurrentCountry(null, () => {
      TabsHelper.deactivateTab(activeTab, currentTabPane);
    });
  }

  setCurrentCountry(countryId, showTabFunction) {
    if (this.currentCountry) {
      this.previousCountry = this.currentCountry;
    }

    this.currentCountry = countryId;

    if (this.shouldLoadVideos) {
      const direction = countryId ? 'To' : 'From';
      this.startTransition(direction, showTabFunction);
    } else {
      showTabFunction();
    }
  }

  static getVideoElementId(index, type) {
    return `map-location-video-${type}-${index}`;
  }

  static getVideoElement(index, type) {
    const videoElement = document.getElementById(MapLocation.getVideoElementId(index, type));
    return videoElement;
  }

  startTransition(direction, showTabFunction) {
    const currentType = direction === 'From' ? 'loop' : '';
    const newType = direction === 'To' ? 'loop' : '';
    const currentVideoElement = MapLocation.getVideoElement(this.videoIndex, currentType);

    currentVideoElement.loop = false;
    currentVideoElement.playbackRate = 10;

    currentVideoElement.addEventListener('ended', () => {
      const transitionType = direction === 'From' ? 'transitionFrom' : 'transitionTo';
      const transitionIndex = direction === 'To' ? this.currentCountry : this.previousCountry;
      const transitionElement = MapLocation.getVideoElement(transitionIndex, transitionType);
      const newVideoIndex = this.currentCountry ? this.currentCountry : 'root';

      transitionElement.addEventListener('ended', () => {
        const loopElement = MapLocation.getVideoElement(newVideoIndex, newType);
        loopElement.loop = true;
        loopElement.playbackRate = 1;
        
        transitionElement.classList.add('previous');
        loopElement.classList.add('current');
        transitionElement.classList.remove('current');
        loopElement.play();
        
        setTimeout(() => {
          transitionElement.classList.remove('previous');
        }, 100);
       
        this.videoIndex = newVideoIndex;

        showTabFunction();
      }, {
        once: true,
      });

      currentVideoElement.classList.add('previous');
      transitionElement.classList.add('current');
      currentVideoElement.classList.remove('current');
      transitionElement.play();
      
      setTimeout(() => {
        currentVideoElement.classList.remove('previous');
      }, 100);
    }, {
      once: true,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable no-new */
  new MapLocation().init();
});
